import { publicApiClient } from '../api/apiClient';

export type CompanySelectStatus = 'ACTIVE' | 'PILOT' | 'SUSPENDED' | 'INACTIVE';

export interface CompanySelectOption {
  id: number;
  name: string;
  description?: string | null;
  status?: CompanySelectStatus;
}

const DEFAULT_PAGE_SIZE = 100;
const MAX_PAGES = 1000;

const normalizeCompany = (company: any): CompanySelectOption | null => {
  if (company?.id == null || !company?.name) return null;

  return {
    id: Number(company.id),
    name: String(company.name),
    description: company.description ?? null,
    status: company.status,
  };
};

export async function loadCompaniesForSelect(pageSize = DEFAULT_PAGE_SIZE): Promise<CompanySelectOption[]> {
  const companies: CompanySelectOption[] = [];
  const seenIds = new Set<number>();

  let page = 0;
  let totalPages: number | null = null;

  while ((totalPages == null || page < totalPages) && page < MAX_PAGES) {
    const response = await publicApiClient.companies.listCompanies(
      undefined,
      undefined,
      page,
      pageSize,
    );
    const data: any = response.data || {};
    const content = Array.isArray(data.content) ? data.content : [];

    for (const rawCompany of content) {
      const company = normalizeCompany(rawCompany);
      if (!company || seenIds.has(company.id)) continue;
      seenIds.add(company.id);
      companies.push(company);
    }

    const parsedTotalPages = Number(data.totalPages);
    totalPages = Number.isFinite(parsedTotalPages) && parsedTotalPages > 0 ? parsedTotalPages : null;
    page += 1;

    if (totalPages == null && content.length < pageSize) break;
  }

  return companies;
}
